import AppConfig from '@app/libs/reactPdfJs/constants/AppConfig';
import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CLEAR_ALL_STATE,
  PDF_SCALE_NORMALIZE,
  PDF_VIEWER_SCALE_CHANGE,
} from '@app/libs/reactPdfJs/store/actionTypes';

type PdfViewerScaleState = number;

const initialState: PdfViewerScaleState = AppConfig.scale.defaultScale;

export default function reducer(state: PdfViewerScaleState = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case PDF_SCALE_NORMALIZE:
      return action.payload.defaultScale;
    case PDF_VIEWER_SCALE_CHANGE:
      return action.payload;
    default:
      return state;
  }
}
